module.exports = __webpack_public_path__ + "img/empty.86da788c.svg";